import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

// ----------------------------------------------------------------------

RHFDatePicker.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
};

export default function RHFDatePicker({ name, helperText, inputSx = {}, ...other }) {
    const { control } = useFormContext();
    // if field is required add an * to the label
    if (other.required) {
        other.label = `${other.label}*`
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                return (
                    <DatePicker
                        {...field}
                        inputFormat="d/M/yy"
                        value={field.value}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => <TextField sx={{ ...inputSx }} {...params} helperText={error ? error?.message : helperText} error={!!error} />}
                        {...other}
                    />
                )
            }}
        />
    );
}
